<template>
  <!-- Section top navigation + sidebar mobile menu -->
  <v-container grid-list-xs fluid class="grid-list-xl text-center nav-wrapper">
    <v-layout align-start justify-center mb-0 pa-0 ma-0 class="nav-items">
      <!-- mobile menu -->
      <MobileMenu />
      <v-flex pa-0 class="main-toolbar">
        <v-app-bar
          fixed
          style="position: inherit"
          text
          :dense="$vuetify.breakpoint.xsOnly ? true : false"
          class="transparent pa-0 elevation-0 nav-bar"
          light
          justify-space-between
          :height="!$vuetify.breakpoint.xsOnly ? 70 : 48"
        >
          <!-- Site logo -->
          <v-toolbar-items id="headerMenu" class pa-0>
            <DrushimLogo />
  
            <NavigationLink
              v-for="(item, index) in navbarLinks"
              :key="index"
              :nav-item="item"
              :itemIndex="index"
              class="menu-item"
              :total="navbarLinks.length - 1"
            />
          </v-toolbar-items>

          <v-toolbar-items class pa-0>
            <UserMenu class="user-menu" mt-2 />
          </v-toolbar-items>
        </v-app-bar>
      </v-flex>
    </v-layout>
  </v-container>
  <!-- top navigation + sidebar mobile menu -->
</template>

<script>
import DrushimLogo from '~/components/NavigationMenu/DrushimLogo';
import NavigationLink from '~/components/NavigationMenu/NavigationLink';
import UserMenu from '~/components/NavigationMenu/UserMenu/UserMenu.vue';
import MobileMenu from '~/components/NavigationMenu/MobileMenu';
import { t } from '@/store/modules/homeDrushim/constantsContent';

export default {
  components: {
    DrushimLogo,
    NavigationLink,
    MobileMenu,
    UserMenu,
  },

  data() {
    return {
      navbarLinks: t('titles.topNavbar')
    }
  }

};
</script>

<style lang="scss" scoped>
.nav-wrapper {
  z-index: 5;
  box-shadow: 0px 6px 10px rgb(0, 0, 0, 0.1);
  padding: 0 5px;
}
.main-toolbar {
  // height: 60px;
  align-items: center;
}
.v-toolbar__content {
  height: auto !important;
  padding: 0 !important;
  justify-content: space-between;
}
.nav-items {
  margin: 0 auto;
}

#headerMenu .menu-item a {
  color: #231f20;
  height: 64px;
  display: flex;
  align-items: flex-end;
  padding: 0px 6px 0px 24px;
  letter-spacing: normal;
  font-size: 16px;
  text-align: right;
  line-height: 16px;
}

#headerMenu .menu-item:last-child a {
  background: $primary;
  text-align: center;
  color: #fff;
  padding: 5px 2px 3px 17px;
  height: 38px;
  flex-direction: row-reverse;
  align-items: center;
  margin-right: 4px;
}

#headerMenu .menu-item:last-child a:after {
  content: '\e906';
  font-family: 'icomoon' !important;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  font-size: 24px;
  display: block;
  padding: 0 5px;
}

.user-menu {
  margin-top: 20px;
}

// @media screen and (max-width: 1660px) {
//   #headerMenu .menu-item a {
//     font-size: 13px;
//   }
// }

// @media screen and (max-width: 1500px) {
//   #headerMenu .menu-item a {
//     font-size: 12px;
//      padding: 0px 0px 0px 28px;
//   }
// }

@media screen and (max-width: 1280px) {
  #headerMenu .menu-item {
    padding: 0px 6px 0px 15px;
  }
  #headerMenu .menu-item a {
    font-size: 14px;
  }
}

@media screen and (max-width: 1160px) {
  #headerMenu .menu-item {
    padding: 0px 6px 0px 5px;
    font-size: 12px;
    line-height: 18px;
  }
}
@media screen and (max-width: 1100px) {
}
@media screen and (max-width: 980px) {
}

@media screen and (max-width: 768px) {
  .nav-wrapper {
    padding: 2px;
  }
}

@media screen and (max-width: 600px) {
}

// @media screen and (max-width: 480px) {

// }
</style>
